import React from "react";
import { Table } from "@dev2_techwalnut/tw-react-crud-dashlite";
import { useForm } from "react-hook-form";
import { useLocation, useNavigate } from "react-router-dom";
import Error from "../../ErrorPages/Error";
import { useAPIQuery } from "../../../hooks/useAPIQuery";

const QCReportDetails = () => {
    const location = useLocation();
    const navigate = useNavigate();
    const qcParaData = location.state?.data;

    const { useFetch: useFetchQCGrid } = useAPIQuery({
        key: "qc-grid",
        endpoint: "/api/check-results/",
    });
    const { useUpdate: useCheckResult } = useAPIQuery({
        key: "check-result",
        endpoint: "/api/check-results/",
    });

    const {
        data: qcGridData,
        isLoading: loadingQCGrid,
        isError: errorLoadingGrid,
        refetch: refetchGrid,
    } = useFetchQCGrid({
        params: {
            q: `${qcParaData?.batch}`,
            c: "qc_batch_id",
            parameter: qcParaData?.parameters?.map((p) => p?.value).join(","),
        },
        staleTime: 0,
    });
    const { mutate: updateQualityCheck, isPending } = useCheckResult({
        params: {
            action: "bulk-update",
        },
        successMessageFromServer: true,
        errorMessageFromServer: true,
        onSuccess: () => {
            navigate("/item-selection");
        },
    });

    const onSubmit = (data) => {
        const result = Object.keys(data)?.map((key) => ({
            id: Number(key?.split("-").pop()),
            actual_result: Number(data[key]),
        }));
        console.log(result);
        updateQualityCheck({ data: result });
    };

    const {
        register,
        handleSubmit,
        formState: { errors },
    } = useForm();

    const columns = [
        {
            accessor: "item_id",
            header: "Parameters/Samples",
            cell: (row) => <span>{row?.sample}</span>,
        },
        ...qcParaData?.parameters.map((param) => ({
            accessor: param?.label,
            header: param?.label,
            cell: (row) => {
                return (
                    <div style={{ display: "flex", flexDirection: "column" }}>
                        <input
                            type="text"
                            defaultValue={row[param.label]?.actual_result}
                            className="form-control"
                            id={`item-${param?.label}-${row[param?.label]?.id}`}
                            {...register(`item-${row[param?.label]?.id}`, {
                                required: true,
                            })}
                            readOnly
                            // onChange={(e) => handleChange(e.target.value)}
                        />
                        {errors?.[`item-${row[param?.label]?.id}`] && (
                            <span className="fs-8 text-danger">
                                Field is required
                            </span>
                        )}
                    </div>
                );
            },
        })),
        ...qcParaData?.parameters.map((param) => ({
            accessor: "result",
            header: "Result",
            cell: (row) => {
                return (
                    <div style={{ display: "flex", flexDirection: "column" }}>
                        <input
                            type="text"
                            defaultValue={row[param.label]?.is_approved}
                            className="form-control"
                            readOnly
                        />
                    </div>
                );
            },
        })),
    ];

    console.log(qcParaData);

    console.log(qcGridData);

    if (!qcParaData || errorLoadingGrid) return <Error />;

    return (
        <>
            <div className="nk-block-head nk-block-head-sm">
                <div className="nk-block-between">
                    <div className="nk-block-head-content">
                        <h4 className="nk-block-title"> Quality Check </h4>
                    </div>
                </div>
            </div>
            <div className="col-lg-12 col-md-12 col-sm-12">
                <div class="card">
                    <div class="card-inner">
                        <form
                            onSubmit={handleSubmit(onSubmit)}
                            autoComplete="off"
                        >
                            <Table
                                data={
                                    qcGridData ? qcGridData?.results?.data : []
                                }
                                columns={columns}
                                isLoading={loadingQCGrid}
                                selectRows={false}
                                globalSearch={false}
                                filterModal={false}
                                editRows={false}
                                deleteRows={false}
                                pagination={false}
                                minWidth={800}
                            />
                            <div className="row g-4 mt-3">
                                <div className="col-12">
                                    <div className="form-group">
                                        <button
                                            type="button"
                                            className="btn btn-md btn-light me-2"
                                            id="submit-button-backbutton"
                                            onClick={() => navigate(-1)}
                                        >
                                            Back
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </>
    );
};

export default QCReportDetails;
